import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useShallow } from "zustand/react/shallow";

/**
 * Checks if the cart item accommodation quantity is greater than
 * the available rate group quantity (rateGroup.maxAvailability)
 */
export const useCheckCartAccommodationAvailibility = () => {
  const { availableRateGroups, cartAccommodationItems } = useEngineStore(
    useShallow((state) => ({
      availableRateGroups: state.availableRateGroups,
      cartAccommodationItems: state.cartAccommodationItems,
    })),
  );

  const mappedCartItemAvailability = availableRateGroups
    ?.map((rg) => {
      const matchingCartItems = cartAccommodationItems.length
        ? cartAccommodationItems?.filter((item) => item.rateGroup.id === rg.id)
        : [];
      if (matchingCartItems.length) {
        return { rateGroup: rg, amountInCart: matchingCartItems.length };
      }
      return;
    })
    ?.filter((item) => item);
  const continueDisabled = mappedCartItemAvailability?.some(
    (item) => item!.amountInCart > item!.rateGroup.maxAvailability,
  );

  return continueDisabled;
};
